export const fmtValue = (v: unknown): string => {
  const n = Number(v ?? 0);
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return String(isNaN(n) ? 0 : n);
};

export const todayStr = () => new Date().toISOString().slice(0, 10);

export const daysAgo = (n: number) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
};

export const shortDate = (iso: string) => {
  const p = iso.split("-");
  return `${p[2]}/${p[1]}`;
};

export const tickFmt = (v: unknown) => fmtValue(v);

export const buildSeries = (
  series: Record<string, { date: string; value: number }[]>,
  keys: string[]
): Record<string, string | number>[] => {
  const map: Record<string, Record<string, number>> = {};
  keys.forEach((k) =>
    (series[k] || []).forEach(({ date, value }) => {
      map[date] = map[date] || {};
      map[date][k] = value;
    })
  );
  return Object.entries(map)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([date, vals]) => ({ date: shortDate(date), ...vals }));
};

export const starToInt = (r?: string): number =>
  ({ ONE: 1, TWO: 2, THREE: 3, FOUR: 4, FIVE: 5 } as Record<string, number>)[r ?? ""] ?? 0;